import SelfInitComponent from "./../../../../../Common/code/Frontend/General/global-js/SelfInitComponent";
import { VideoPlayer } from "./../Scripts/videoplayer";

import "./../../Player/Styles/mejs.scss";
import "./../Styles/videoplayer.scss";

class VideoPlayerComponent extends SelfInitComponent {
    constructor(selector) {
        super(selector);
    }

    init() {
        VideoPlayer.init();
    }
}

new VideoPlayerComponent(".videoPlayer");